import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { CountrySelector } from '@shared/infrastructure/ui/components/selector/countrySelector/countrySelector';
import { LanguageSelector } from '@shared/infrastructure/ui/components/selector/languageSelector/languageSelector';

export function Header() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static'>
        <Toolbar>
          <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
            Virtual Clinic Content Management
          </Typography>
          <CountrySelector></CountrySelector>
          <LanguageSelector></LanguageSelector>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
